import { ConfigCommonLabels } from '@net7/boilerplate-common';

export default {
  descrizione: '',
} as ConfigCommonLabels;
